import axios from 'axios';
import { getToken } from './auth';

// Auto-detect API URL: use relative path in production, localhost in dev
const getApiUrl = () => {
  // If REACT_APP_API_URL is set, use it
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // In production (served from same domain), use relative path
  if (process.env.NODE_ENV === 'production') {
    return '/api';
  }
  
  // In development, use localhost
  return 'http://localhost:4000/api';
};

const api = axios.create({
  baseURL: getApiUrl(),
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - attach auth token (admin or affiliate)
api.interceptors.request.use(
  (config) => {
    // Check if this is an affiliate route
    const isAffiliateRoute = config.url?.startsWith('/affiliates');
    
    // Get the appropriate token
    let token;
    if (isAffiliateRoute) {
      token = localStorage.getItem('affiliateToken');
    } else {
      token = getToken(); // Admin token
    }
    
    // Only set Authorization if we have a token AND it's not already set
    if (token && !config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      // Redirect to login if unauthorized
      if (error.response.status === 401) {
        const isAdminRoute = window.location.pathname.startsWith('/admin');
        const isAffiliateRoute = window.location.pathname.startsWith('/affiliate');
        
        if (isAdminRoute && window.location.pathname !== '/admin/login') {
          window.location.href = '/admin/login';
        } else if (isAffiliateRoute && window.location.pathname !== '/affiliate/login') {
          localStorage.removeItem('affiliateToken');
          window.location.href = '/affiliate/login';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;
